/**
 * 문자열의 숫자값만 문자열로 반환합니다.
 * @param value
 * @returns string
 */
export default function getOnlyNumber(value: string) {
  if (value === undefined) {
    return '';
  }
  return value.replace(/\D/g, '');
}
